import { FormGroup } from "@angular/forms";

export abstract class AdminFormGroup extends FormGroup {
  abstract getItem(): any;
}
